import React, { useState } from "react";
import ReactPlayer from "react-player/wistia";
import Picture from "../picture";
import css from "./index.module.scss";

export default function Wistia({videoId, imageBase}) {
  return <div className={css.wistia}>
    <ReactPlayer url={`https://deviatelabs.wistia.com/medias/${videoId}`}
      light={ <Picture
        base={imageBase}
        exts={["webp", "png"]}
        widths={[500, 1000, 1500, 2000]}
        loading="lazy"
        sizes="100vw"
        alt="Video thumbnail"
      />}
      width="100%"
      height="100%"
      config={
        {
          wistia: {
            options: {
              autoPlay: true,
              playbar: true,
            },
          },
        }
      }
    />
  </div>;
}
